import React from 'react';
import classNames from 'classnames';
import { IGeoLocation, IImage, ILink } from 'utils/types';
import { PipelineMap } from './PipelineMap';
import ChevronRight from 'components/assets/chevron-right.svg';

import s from './Pipeline.module.scss';
import Link from 'next/link';

type Props = {
  title: string;
  biosimilarCandidate: string;
  referenceBiologic: string;
  therapeuticArea: string;
  map?: IImage;
  approvals?: Array<{
    name: string;
    location?: IGeoLocation;
  }>;
  currentStage: string;
  steps?: string[];
  link?: ILink;
};

export const PipelineItem = ({
  title,
  biosimilarCandidate,
  referenceBiologic,
  therapeuticArea,
  map,
  approvals,
  currentStage,
  steps,
  link,
}: Props) => {
  const stages = steps || [
    'Early Phase',
    'Pre-clinical',
    'Clinical Trials',
    'Filing',
    'Approval',
    'Launch',
  ];

  return (
    <li className={s.pipelineItem}>
      <h3 className={s.pipelineItem__title}>{title}</h3>
      <ul className={s.pipelineItem__stages}>
        {stages.map((stage, index) => {
          if (index === stages.length - 1 && currentStage === stage) {
            console.log('currentStage', currentStage);

            return (
              <li key={index} className={classNames(s.pipelineItem__stage, s.active)}>
                <Link {...link}>
                  <a className={s.pipelineItem__link}>
                    {stage}
                    <span className={s.pipelineItem__checkbox} />
                  </a>
                </Link>
              </li>
            );
          }

          return (
            <li
              key={index}
              className={classNames(s.pipelineItem__stage, { [s.active]: currentStage === stage })}
            >
              {stage}
              {index < stages.length - 1 ? (
                <ChevronRight className={s.pipelineItem__icon} />
              ) : (
                <span className={s.pipelineItem__checkbox} />
              )}
            </li>
          );
        })}
      </ul>
      <div className={s.pipelineItem__details}>
        <dl className={s.pipelineItem__info}>
          {biosimilarCandidate && (
            <div className={s.pipelineItem__infoItem}>
              <dt className={s.pipelineItem__infoType}>Biosimilar candidate</dt>
              <dd className={s.pipelineItem__infoDefinition}>{biosimilarCandidate}</dd>
            </div>
          )}
          {referenceBiologic && (
            <div className={s.pipelineItem__infoItem}>
              <dt className={s.pipelineItem__infoType}>Reference biologic</dt>
              <dd className={s.pipelineItem__infoDefinition}>{referenceBiologic}</dd>
            </div>
          )}
          {therapeuticArea && (
            <div className={s.pipelineItem__infoItem}>
              <dt className={s.pipelineItem__infoType}>Therapeutic area</dt>
              <dd className={s.pipelineItem__infoDefinition}>{therapeuticArea}</dd>
            </div>
          )}
        </dl>
        {/* {approvals?.length > 0 && (
          <div className={s.pipelineItem__approvals}>
            <h4 className={s.pipelineItem__approvalsTitle}>Approved by</h4>
            <ul className={s.pipelineItem__approvalsList}>
              {approvals?.map((approval, index) => (
                <li key={index} className={s.pipelineItem__approvalsItem}>
                  {approval.name}
                </li>
              ))}
            </ul>
          </div>
        )} */}

        <div className={s.pipelineItem__map}>
          <PipelineMap map={map} approvals={approvals} />
        </div>
      </div>
    </li>
  );
};
